/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface RuleScript
 */
export interface RuleScript {
    /**
     * 
     * @type {number}
     * @memberof RuleScript
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleScript
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof RuleScript
     */
    dateCreated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof RuleScript
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the RuleScript interface.
 */
export function instanceOfRuleScript(value: object): boolean {
    return true;
}

export function RuleScriptFromJSON(json: any): RuleScript {
    return RuleScriptFromJSONTyped(json, false);
}

export function RuleScriptFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleScript {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'content': json['content'] == null ? undefined : json['content'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function RuleScriptToJSON(value?: RuleScript | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'content': value['content'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'isDraft': value['isDraft'],
    };
}

